import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class ExportIcon extends BaseIcon {
  getChildren = () => [
    <g fill={ this.getColor() }>
      <path d="M2,9h6.5C8.7,8.9,8.8,8.9,9,8.8V8H2V9z"/>
      <rect x="2" y="6" width="7" height="1"/>
      <path d="M4.8,13H1V3h9v3.8L11,6V1H8c0-0.6-0.4-1-1-1H4C3.4,0,3,0.4,3,1H0v12c0,0.6,0.4,1,1,1h3.4  C4.5,13.7,4.6,13.4,4.8,13z"/>
      <path d="M2,11h4c0.3-0.3,0.6-0.7,0.9-1H2V11z"/>
      <path d="m12 8l4.2 3.4-4.2 3.6v-2c-0.7-0.1-1.4 0-2.1 0.2-1.4 0.2-2.7 0.8-3.8 1.9 0 0 1.1-3.7 3.9-4.4 1.2-0.3 1.5-0.5 2-0.6v-2.1z"/>
    </g>
  ]
  getViewBox = () => '0 0 16 16'
}
